import { Component, Input, OnInit, inject } from '@angular/core';
import { SelectService } from '../select.service';

@Component({
  selector: 'app-option',
  templateUrl: './option.component.html',
  styleUrls: ['./option.component.scss'],
  standalone: false
})
export class OptionComponent implements OnInit {
  private selectService = inject(SelectService);

  @Input() value: any;
  @Input() displayText: string;
  private selected: string;

  ngOnInit() {
    this.selectService.currentSelected.subscribe((selected) => {
      this.selected = selected;
    });
  }

  onClick() {
    this.selectService.setSelect(this.value);
    this.selectService.setDisplay(this.displayText);
  }

  get isSelected(): boolean {
    return this.selected === this.value;
  }
}
